import * as React from 'react';
import RacingParticipantsTable from '../RacingParticipantsTable';
import RacingParticipantResultDto from '../../models/dtos/RacingParticipantResultDto';

export default function MatchParticipantsTab(props: { participants: RacingParticipantResultDto[]; resultRaw?: string }) {
    return <RacingParticipantsTable participants={props.participants} resultRaw={props.resultRaw} />;
}
